import { render } from "./ClosedIcon.vue?vue&type=template&id=87e98fb8"
const script = {}

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__